import { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc } from "firebase/firestore";

console.log("ReservationForm.js が実行されています！");

export default function ReservationForm() {
  const [name, setName] = useState("");
  const [people, setPeople] = useState("1");
  const [email, setEmail] = useState("");
  const [date, setDate] = useState("");
  const [hour, setHour] = useState("14");
  const [minute, setMinute] = useState("00");
  const [errorMessage, setErrorMessage] = useState("");
  const [area, setArea] = useState("");
  const [quantity, setQuantity] = useState("1");
  const [taste, setTaste] = useState("");
  const [note, setNote] = useState("");

  const getToday = () => new Date().toISOString().split("T")[0];
  const SWEET_CAMEL_MESSAGE = "【Sweet Camelからのメッセージ】";

  // 予約受付は何日後からかの調整部分（1日なら1,3日なら3と定数を入れる）
  const RESERVATION_OFFSET_DAYS = 3;

  const getMinReservationDate = () => {
    const now = new Date();
    now.setDate(now.getDate() + RESERVATION_OFFSET_DAYS);
    return now.toISOString().split("T")[0];
  };


  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    setDate(selectedDate);

    const minDate = getMinReservationDate();

    if (selectedDate < minDate) {
      setErrorMessage(`予約は${RESERVATION_OFFSET_DAYS}日後以降から可能です。`);
      return;
    }

    const availableHours = getAvailableHours(selectedDate);
    if (availableHours.length === 0) {
      setErrorMessage("本日の予約は受付終了しました。別の日付を選択してください。");
      return;
    }

    setErrorMessage("");
    setHour(availableHours[0]);
    setMinute("00");
  };

  const getAvailableHours = (selectedDate) => {
    if (!selectedDate) return [];

    let startHour = 14;
    let endHour = 24; // 24:00 まで予約可能

    const today = getToday();
    const now = new Date();

    if (selectedDate === today) {
      const currentHour = now.getHours();
      if (currentHour >= endHour) {
        return [];
      }
      startHour = Math.max(startHour, currentHour + 1);
    }

    return Array.from({ length: endHour - startHour + 1 }, (_, i) => (startHour + i).toString().padStart(2, "0"));
  };


  const formatDate = (dateStr) => {
    const dateObj = new Date(dateStr);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}年${month}月${day}日`;
  };


  const handleSubmit = async () => {
    if (!name || !email || !date || !hour || !minute || !area || !quantity || !taste) {
      alert(`${SWEET_CAMEL_MESSAGE}\n\nすべての必須項目を入力してください。`);

      return;
    }

    if (errorMessage) {
      alert(`${SWEET_CAMEL_MESSAGE}\n\n${errorMessage}`);
      return;
    }

    const now = new Date();
    const selectedDateTime = new Date(`${date}T${hour}:${minute}:00`);
    if (selectedDateTime < now) {
      setErrorMessage("予約日時が過ぎています。再度正しい日時を選択してください。");
      return;
    }

    const formattedDate = formatDate(date);
    const time = `${hour}:${minute}`;
    const reservationDetails = `こちらの予約内容でお間違いないですか？\n\n`
      + `お名前: ${name}\n`
      + `来店人数: ${people}人\n`
      + `メールアドレス: ${email}\n`
      + `予約日時: ${formattedDate} ${time}\n`
      + `エリア: ${area}\n`
      + `注文台数: ${quantity}台\n`
      + `希望の味: ${taste}\n`
      + (note ? `その他: ${note}\n` : "");

    const confirmReservation = window.confirm(`${SWEET_CAMEL_MESSAGE}\n\n${reservationDetails}`);
    if (!confirmReservation) {
      alert(`${SWEET_CAMEL_MESSAGE}\n\n再度予約内容をご確認ください。`);
      return;
    }

    const reservationData = {
      name,
      people,
      email,
      date,
      time,
      area,
      quantity,
      taste,
      note,
      createdAt: new Date(),
    };

    console.log("Firestore に送信するデータ:", reservationData);

    try {
      const docRef = await addDoc(collection(db, "reservations"), reservationData);
      console.log("Firestore 送信成功: ドキュメントID:", docRef.id);

      const endpoints = [
        "https://totonoe.info/webhook.php",
        "https://totonoe.info/google_sheets.php"
      ];

      await Promise.all(
        endpoints.map(async (endpoint) => {
          try {
            const response = await fetch(endpoint, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(reservationData),
              mode: "cors",
            });

            const data = await response.text();
            console.log(`${endpoint} 送信結果:`, data);

            if (!response.ok) {
              throw new Error(`エラー: ${response.status} ${response.statusText}`);
            }
          } catch (error) {
            console.error(`${endpoint} 送信エラー:`, error);
          }
        })
      );

      alert(`${SWEET_CAMEL_MESSAGE}\n\n予約が完了しました。\n当日のご来店をお待ちしております！`);
    } catch (error) {
      console.error("Firestore 送信エラー", error);
      alert(`${SWEET_CAMEL_MESSAGE}\n\n予約に失敗しました。\nお手数ですが再度お試しください。`);
    }
  };

  return (
    <div>
      <h2> SweetCamel 出張ご予約フォーム</h2>
      <label>お名前（*必須） </label>
      <input placeholder="山田 太郎" value={name} onChange={(e) => setName(e.target.value)}/>
      <br/>
      <label>メールアドレス（*必須） </label>
      <input type="email" placeholder="sample.gmail.com" value={email} onChange={(e) => setEmail(e.target.value)} />
      <br/>
      <label>ご来店人数（*必須） </label>
      <select value={people} onChange={(e) => setPeople(e.target.value)}>
        <option value="1">1人</option>
        <option value="2">2人</option>
        <option value="3">3人</option>
        <option value="4">4人</option>
        <option value="5">5人</option>
        <option value="6+">6人以上</option>
      </select>
      <br/>
      <label>配達エリア（*必須）</label>
      <select value={area} onChange={(e) => setArea(e.target.value)} required>
        <option value="">選択してください</option>
        <option value="大阪市内">大阪市内</option>
        <option value="大阪市外">大阪市外</option>
        <option value="その他※最後の「その他」に必ず配達エリアをご記載ください">その他</option>
      </select>
      <br/>
      <label>注文台数（*必須）</label>
      <select value={quantity} onChange={(e) => setQuantity(e.target.value)} required>
        <option value="1">1台</option>
        <option value="2">2台</option>
        <option value="3">3台</option>
        <option value="4">4台</option>
        <option value="5+">5台以上</option>
      </select>
      <br/>
      <label>ご希望の味（*必須）</label>
      <input
        type="text"
        placeholder="例：レモン、コーラ、ブルーベリーなど"
        value={taste}
        onChange={(e) => setTaste(e.target.value)}
        required
      />
      <br/>
      <label>日付（*必須）</label>
      <input type="date" value={date} onChange={handleDateChange} min={getMinReservationDate()} />
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      <br/>
      <label>時間（*必須）</label>
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      <select value={hour} onChange={(e) => setHour(e.target.value)}>
        {Array.from({ length: 11 }, (_, i) => (14 + i).toString().padStart(2, "0")).map((h) => (
          <option key={h} value={h}>{h}時</option>
        ))}
      </select>
      <select value={minute} onChange={(e) => setMinute(e.target.value)}>
          {["00", "10", "20", "30", "40", "50"].map((m) => (
            <option key={m} value={m}>{m}分</option>
          ))}
      </select>
      </div>
      {/* その他（ここを時間の下に移動） */}
      <div className="form-group">
        <label>その他（任意）</label>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="ご要望などがあればご記入ください"
          style={{ width: "100%", height: "80px" }}
        />
      </div>
      <br/>

      <button onClick={handleSubmit} disabled={!!errorMessage}>予約する</button>
    </div>
  );
}
